interface CancellationSummaryProps {
  status?: { code?: string | null } | null;
  reason?: { display?: string | null } | null;
  note?: string | null;
  /**
   * Leave out the word "Cancelled" where a status row right above already says it
   * (the details page status block), so it does not show twice.
   */
  hideStatusLabel?: boolean;
}

/**
 * Cancelled appointments only: `Cancelled · {reason}` with the free-text note
 * directly under it. A note without a reason shows bare `Cancelled` + the note.
 * Renders nothing for any other status, or when neither reason nor note exists.
 *
 * "Cancelled" is read the way `ViewAppointmentPopup` already reads it
 * (status code `cancelled` / `canceled`, case-insensitive).
 */
export function CancellationSummary({ status, reason, note, hideStatusLabel = false }: CancellationSummaryProps) {
  const code = (status?.code ?? '').toLowerCase();
  if (code !== 'cancelled' && code !== 'canceled') return null;

  const reasonText = reason?.display?.trim();
  const noteText = note?.trim();
  if (!reasonText && !noteText) return null;
  const heading = hideStatusLabel ? reasonText : reasonText ? `Cancelled · ${reasonText}` : 'Cancelled';

  return (
    <div className="flex flex-col gap-1 text-sm min-w-0">
      {heading ? <span className="font-semibold text-text-primary">{heading}</span> : null}
      {noteText ? (
        <span className="text-text-muted whitespace-pre-wrap break-words">
          {noteText}
        </span>
      ) : null}
    </div>
  );
}
